<template>
  <div class="card simpleWorkflow">
    <div class="simpleWorkflow__item">
      <span>When</span>
      <b-form-select v-model="workflow.whenTrigger" :options="availableWorkflowTriggers" size="sm" />

      <BtnClickedWorkflow
        v-if="workflow.whenTrigger === 'btnClicked'"
        :eventBus="eventBus"
        :workflow="workflow"
      />
      <RowCreatedWorkflow
        v-if="workflow.whenTrigger === 'rowCreated'"
        :eventBus="eventBus"
        :workflow="workflow"
      />
      <RowUpdatedWorkflow
        v-if="workflow.whenTrigger === 'rowUpdated'"
        :eventBus="eventBus"
        :workflow="workflow"
      />
      <FiledUpdatedWorkflow
        v-if="workflow.whenTrigger === 'fieldUpdated'"
        :eventBus="eventBus"
        :workflow="workflow"
      />
    </div>

    <!-- <div>{{ workflow }}</div> -->

    <div>
      <b-button v-if="mutated" variant="primary" size="sm" @click="save" :disabled="inProcess">
        <icon name="save" />
        <span>Save</span>
      </b-button>
    </div>
    <b-button
      variant="danger"
      size="sm"
      class="simpleWorkflow__itemRemove"
      @click="remove"
      :disabled="inProcess"
    >
      <icon name="remove" />
    </b-button>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
// services
import db from '@/services/db'
// components
import BtnClickedWorkflow from './types/BtnClicked'
import RowCreatedWorkflow from './types/RowCreated'
import RowUpdatedWorkflow from './types/RowUpdated'
import FiledUpdatedWorkflow from './types/FieldUpdated'

export default {
  props: ['workflowItem', 'workflowKey'],
  components: {
    BtnClickedWorkflow,
    RowCreatedWorkflow,
    RowUpdatedWorkflow,
    FiledUpdatedWorkflow,
  },
  data() {
    return {
      eventBus: new Vue(),
      workflow: this.workflowItem,
      inProcess: false,
      availableWorkflowTriggers: [
        { text: 'A Button Is Clicked', value: 'btnClicked' },
        { text: 'A Row Is Created', value: 'rowCreated' },
        { text: 'A Row Is Updated', value: 'rowUpdated' },
        { text: 'A Field Is Updated', value: 'fieldUpdated' }
      ],
    }
  },
  watch: {
    'workflow.whenTrigger'(value) {
      this.workflow = { whenTrigger: value }
    },
  },
  computed: {
    ...mapState(['simpleWorkflows']),
    mutated() {
      return (
        this.simpleWorkflows[this.workflowKey] !== JSON.stringify(this.workflow)
      )
    },
  },
  methods: {
    save() {
      this.inProcess = true

      db.simpleWorkflow.save(
        this.workflowKey,
        JSON.stringify(this.workflow),
        () => {
          this.inProcess = false

          this.$emit('updated', this.workflowKey)
        }
      )
    },
    remove() {
      if (!confirm('Are you sure?')) return

      this.inProcess = true

      db.simpleWorkflow.remove(this.workflowKey, () => {
        this.$emit('removed', this.workflowKey)
      })
    },
    addAction() {
      const currentActions = this.workflow.actions || []

      currentActions.push({})

      this.workflow = Object.assign({}, this.workflow, {
        actions: currentActions,
      })
    },
    setAction(action, idx) {
      const currentActions = this.workflow.actions || []

      currentActions[idx] = action

      this.workflow = Object.assign({}, this.workflow, {
        actions: currentActions,
      })
    },
    removeAction(idx) {
      const currentActions = this.workflow.actions || []

      currentActions.splice(idx, 1)

      this.workflow = Object.assign({}, this.workflow, {
        actions: currentActions,
      })
    },
  },
  created() {
    this.eventBus.$on('addAction', this.addAction)
    this.eventBus.$on('setAction', this.setAction)
    this.eventBus.$on('removeAction', this.removeAction)
  },
}
</script>
